import { combineReducers } from 'redux';

import loadError from './loadError';

export default combineReducers({
  loadError,
});
